/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { AddToBasketLayerFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { AddToBasketLayerFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { rest } from 'msw';
import { taxHintDataMock } from '../TaxHint/mockdata';

export const addToBasketLayerDataMock: AddToBasketLayerFragmentFragment = {
  availability: {
    state: 'AVAILABLE',
  },
  brand: {
    name: 'Markenname',
  },
  defaultCategory: '10041',
  delivery: taxHintDataMock,
  hasSeries: false,
  orderNumber: '7353915',
  price: {
    value: 51472,
  },
};

export function getAddToBasketLayerFragmentedData(data?: AddToBasketLayerFragmentFragment) {
  return makeFragmentData(data || addToBasketLayerDataMock, AddToBasketLayerFragmentFragmentDoc);
}

export const addToBasketErrorHandler = [
  rest.put('/api/checkout/v1/', (_, res, ctx) => res(ctx.status(500))),
];
